import styled from 'styled-components'
import { ArrowDown, ArrowUp } from 'react-feather'

export const Container = styled.div`
    display: flex;
    gap: 1rem;
    margin-bottom: 0.8rem;
`

export const ArrowUpIcon = styled(ArrowUp)`
    cursor: pointer;
    width: 1rem;
`

export const ArrowDownIcon = styled(ArrowDown)`
    cursor: pointer;
    width: 1rem;
`
